import React from "react";
import { Link, useParams, useLocation } from "react-router-dom";

const DetailMovies = () => {
  const title = useParams().title.split("-").join(" ");
  const film = useLocation().state;

  return (
    <>
      <div
        style={{
          display: "flex",
          margin: "40px 0 0 75px",
          textAlign: "left",
        }}
      >
        <Link to="/" style={{ marginRight: "20px" }}>
          Home
        </Link>
        <svg
          width="1em"
          height="1em"
          viewBox="0 0 16 16"
          className="bi bi-caret-right-fill"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          style={{ marginTop: "5px", marginRight: "20px" }}
        >
          <path d="M12.14 8.753l-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
        </svg>
        <p>{title}</p>
      </div>

      <div
        className="container border shadow"
        style={{ marginTop: "40px", padding: "0px" }}
      >
        <div style={{ display: "flex" }}>
          <img
            style={{ height: "400px", width: "450px" }}
            src={film.Poster}
            alt="poster film"
          ></img>
          <div style={{ margin: "20px 20px 20px 50px", textAlign: "left" }}>
            <h3>Judul Film: {film.Title}</h3>
            <h3>Tahun Rilis: {film.Year}</h3>
            <h3>IMDB ID: {film.imdbID}</h3>
          </div>
        </div>
      </div>
    </>
  );
};

export default DetailMovies;
